export const organization = {
  routes: [
    {
      path: "/organization/thirdparty",
      component: () => import("../organization-thirdparty-view"),
    },
  ],
};
